import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";

const Healthcs1 = () => {
    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/healthcs1img.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "black",  marginTop:"-300px"  , fontWeight:"bold" , fontSize: { xs: "28px", md: "70px" }}}>
         
          Revenue Cycle Management Streamlined for Success
          </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
      <Typography variant="body1" sx={{ color: "#333", fontSize: "18px" }}>
      Tech Informatic Solutions sought digital process improvements that would streamline operations and mitigate rising complexity and costs.
          </Typography>
      <Typography variant="body1" sx={{ mt: 2, color: "#333", fontSize: "18px"  }} mb={8}>
      The organization partnered with Tech Informatic Solutions to optimize revenue cycle management workflows that improve productivity and operational efficiency.
          </Typography>
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Business Needs
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        As the costs of healthcare delivery continue to rise, healthcare payers create ever more complex demands for processing claims. For example, claim denials issued by payers are frequent; they create costly rework, impeding revenue collection.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        To address the demands put on them by payers, healthcare providers often outsource their claims processing to revenue cycle management (RCM) companies that specialize in managing claims and collecting revenue for patient services.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Tech Informatic Solutions Medical Management has been providing revenue cycle management services to independent physicians since 2001. The company’s goal is to maximize collections for its physician clients while providing them with actionable insights into their business.  </Typography>



         {/* outcome Section */}
       <Typography variant="h4" fontWeight="bold" mb={-12}>
         Outcomes
        </Typography>
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={8}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Knowledge management system helps in efficient AR management",
                "ERA auto posting review transformation reduces exceptions by nearly 100%",
                "AR workflow simplification resulted in multiple touch reduction"
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Denial posting automation fully eliminates manual work in 37% of denials and reduces manual work to a single step in the remaining 63%",
                "30,000 transactions/month processed with nearly 100% accuracy using robotics automation",
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>


      <Container sx={{ py: 10 }}>
      
       
      <Typography  variant="h4" fontWeight="bold" mb={3}>
      Solution
          </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Success demands accuracy and efficiency
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        “Revenue cycle management is a highly competitive market. Our clients pay us a set fee to process a claim on their behalf. We don’t get paid to rework a claim, so our business success relies on processing claims accurately and as efficiently as possible. It’s critical that we strive to get the work done right the first time.”
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Tech Informatic Solutions  continuously evaluates its revenue cycle management workflows in pursuit of best practices. To that end, Tech Informatic Solutions  has a long history of partnership with Tech Informatic Solutions and its Business Process Outsourcing teams. Their journey together encompasses designing services and driving efficiencies in many RCM workflows including:
        </Typography>





        <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={8}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Development of a knowledge management system for claims processing",
                "Optimizing accounts receivable (AR) workflows",
              
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Automation and scripting applied to denial posting",
                "30,000 transactions /month processed with nearly 100% accuracy using robotics automation",
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>



        
</Container>



<Footer/>
    </Box>


  );
};

export default Healthcs1;
